import { $OpenApiTs } from 'app/API';

type TAuditLogOrderBy = NonNullable<$OpenApiTs['/api/admin/audit-logs']['get']['req']['orderBy']>;

const auditLogOrderByFields = [
  'createdAt',
  'entityType',
  'action',
  'businessAction',
  'actorType',
] as const satisfies readonly TAuditLogOrderBy[];

export const toAuditLogOrderBy = (value: string): TAuditLogOrderBy | undefined =>
  auditLogOrderByFields.find((field) => field === value);
